import { apiSlice } from './apiSlice';

const ERROR_LOGS_URL = '/api/error-logs';

export const errorLogsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getErrorLogs: builder.query({
      query: ({ source = '', q = '', limit = 100 } = {}) => ({
        url: `${ERROR_LOGS_URL}?source=${encodeURIComponent(source)}&q=${encodeURIComponent(q)}&limit=${encodeURIComponent(limit)}`,
        method: 'GET',
      }),
      providesTags: ['ErrorLogs'],
    }),
    clearErrorLogs: builder.mutation({
      query: () => ({
        url: ERROR_LOGS_URL,
        method: 'DELETE',
      }),
      invalidatesTags: ['ErrorLogs'],
    }),
  }),
});

export const { useClearErrorLogsMutation, useGetErrorLogsQuery } = errorLogsApiSlice;
